import { HelpHero } from 'helphero';
import { useContext } from 'react';

import { HelpHeroContext } from '../context/help-hero-context';

const useHelpHero = (): HelpHero => useContext(HelpHeroContext);

export default useHelpHero;
